module.exports = __webpack_public_path__ + "img/42exp.d7587e23.jpg";